import { render, staticRenderFns } from "./Confirm_order_detail.vue?vue&type=template&id=410f25fc&scoped=true&"
import script from "./Confirm_order_detail.vue?vue&type=script&lang=js&"
export * from "./Confirm_order_detail.vue?vue&type=script&lang=js&"
import style0 from "./Confirm_order_detail.vue?vue&type=style&index=0&id=410f25fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f25fc",
  null
  
)

export default component.exports